type RequiredKey = 'VITE_SUPABASE_URL' | 'VITE_SUPABASE_ANON_KEY';

function required(name: RequiredKey): string {
  const value: unknown = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(`Missing environment variable ${name}`);
  }
  return value;
}

function optional(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL'),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY'),
  /** Base URL of apps/api without a trailing slash; empty string → same origin (/api proxied by Vite / Caddy). */
  apiUrl: optional(import.meta.env.VITE_API_URL).replace(/\/+$/, ''),
} as const;
